import { useMainStore } from "@/store";

class ImageManager {
  async preloadImages(ranges) {
    useMainStore().pingState = "preloading";
    return new Promise((resolve) => {
      useMainStore().pingState = "start";
      const store = useMainStore();
      const container = document.getElementById("preload");
      useMainStore().pingState = "before get urls";
      const urls = this.getImagesUrls(ranges);
      const max = urls.length;
      useMainStore().pingState = "nb url : " + max;
      let count = 1;
      let percent = 0;
      useMainStore().pingState = "before foreach";
      urls.forEach((url) => {
        useMainStore().pingState = "map : " + count;
        this.preload(url, container).then((res) => {
          if (res && Object.keys(res).length) {
            useMainStore().pingState = "nb images loaded : " + count;
            count++;
            percent = Math.ceil((count / max) * 100);
            if (percent <= 100) {
              store.setCounter(percent);
            }
            if (count === max) {
              resolve({ success: true });
            }
          }
        });
      });
    });
  }

  async preload(url, container) {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      container.append(img);
      img.onload = resolve;
    });
  }

  getImagesUrls(ranges) {
    let urls = [];
    useMainStore().pingState = "getting urls";
    Object.values(ranges).forEach((range) => {
      useMainStore().pingState = "getting urls from range " + range.id;
      if (range.menu_photo) {
        urls.push(this.picture(range.menu_photo, "min2"));
      }
      if (range.photo_tv) {
        urls.push(this.picture(range.photo_tv, "tv_zoom"));
      } else if (range.photo) {
        urls.push(this.picture(range.photo, "bandeau"));
      }
      Object.values(range.vehicles).forEach((vehicle) => {
        Object.values(vehicle.models).forEach((model) => {
          useMainStore().pingState = "getting urls from model " + model.id;
          if (model.thumbnail) {
            urls.push(this.picture(model.thumbnail, "mobile"));
          }
          if (model.mobile_photo) {
            urls.push(this.picture(model.mobile_photo, "zoom"));
          }
          if (model.gallery) {
            Object.values(model.gallery).forEach((gallery) => {
              useMainStore().pingState =
                "getting urls from gallery " + gallery.id;
              if (gallery.url) {
                urls.push(this.picture(gallery.url, "tv_zoom"));
                urls.push(this.picture(gallery.url, "tv_min"));
              }
            });
          }
        });
      });
    });
    return urls;
  }

  picture(source, prefix = null) {
    let split = source.split("/");
    const name = split.pop();
    return split.join("/") + "/" + prefix + "_" + name;
  }
}

export const imageManager = new ImageManager();
